module.exports = __webpack_public_path__ + "0951527850f27978a80d693665b77ba0.svg";